module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert.cf2e803a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert.png
// module id = 1051
// module chunks = 16